import { Notification } from "@cnx/common";
import { Box, Flex, Modal, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import dayjs from "dayjs";
import { useUpdateNotificationStatus } from "hooks/useNotifications";
import { useTranslation } from "react-i18next";
import { selectIconByNotificationType } from "utils/notifications";
import NotificationLayout from "../NotificationLayout";
import NotificationTitle from "../NotificationTitle";
import NotificationCardPreview from "./NotificationCardPreview";
import ChangeViewer from "./NotificationCardPreview/ChangeViewer";

interface NotificationCardProps {
  notification: Notification;
}

const NotificationCard: React.FC<NotificationCardProps> = ({
  notification,
}) => {
  const { t } = useTranslation("notifications");

  const {
    title,
    description,
    createdTime,
    notificationTypeKey,
    notificationTypeName,
    trailerLicenceNumber,
  } = notification;

  const icon = selectIconByNotificationType({
    notificationType: notificationTypeKey,
  });

  const updateNotificationRecipient = useUpdateNotificationStatus();

  const [opened, { close, open }] = useDisclosure();

  const handleCloseNotification = async () => {
    close();
    await updateNotificationRecipient(notification.id, { viewed: true });
  };

  return (
    <>
      <Flex p={"sm"} align={"center"} gap={"md"} onClick={open}>
        <Box ml={{ base: 5, sm: 25 }}>{icon}</Box>
        <Stack className={"flex-1"} gap={4}>
          <NotificationTitle
            notificationTypeName={notificationTypeName}
            title={title}
            trailerLicenceNumber={trailerLicenceNumber}
          />
          {description && (
            <Text lh={1} fz={12}>
              {description}
            </Text>
          )}
          <Text c={"gray"} lh={1} fz={10}>
            {dayjs(createdTime).format(t("createdAtFormat"))}
          </Text>
        </Stack>
      </Flex>

      <Modal
        fullScreen
        withCloseButton={false}
        classNames={{ body: "!p-0" }}
        opened={opened}
        onClose={close}
      >
        <NotificationLayout
          goBack={handleCloseNotification}
          title={<NotificationCardPreview notification={notification} />}
        >
          <ChangeViewer goBack={close} notification={notification} />
        </NotificationLayout>
      </Modal>
    </>
  );
};

export default NotificationCard;
